import { createElement } from "react";
import React from "react";
import * as react from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Typography } from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export function Components_Shortcut_Z74A6BA73(components_Shortcut_Z74A6BA73InputProps) {
    let elems_2, elems_1, elems, props_3;
    const icon = components_Shortcut_Z74A6BA73InputProps.icon;
    const href = components_Shortcut_Z74A6BA73InputProps.href;
    const lower = components_Shortcut_Z74A6BA73InputProps.lower;
    const upper = components_Shortcut_Z74A6BA73InputProps.upper;
    return createElement("a", {
        style: {
            textDecorationLine: "none",
        },
        href: href,
        children: createElement("div", createObj(ofArray([["className", join(" ", ["shortcut-container"])], ["style", {}], (elems_2 = [icon([["style", {
            fontSize: 4 + "rem",
        }]]), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            columnGap: 10 + "px",
        }], (elems_1 = [MuiHelpers_createElement(Typography, [["sx", {
            whiteSpace: "nowrap",
        }], ["variant", "h3"], ["children", upper]]), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            columnGap: 10 + "px",
        }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", lower]]), (props_3 = {}, react.createElement(ArrowForward, props_3))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
    });
}

